module.exports = "https://web-assets.ifttt.com/packs/media/privacy/greater-than-61d4f7ec.svg";